var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Button, Icon } from "./..";
export var CardHeaderAction = function (_a) {
    var icon = _a.icon, label = _a.label, _b = _a.iconPalette, iconPalette = _b === void 0 ? 'secondary' : _b, props = __rest(_a, ["icon", "label", "iconPalette"]);
    return (React.createElement(Button, __assign({ palette: "primary", scale: "sm", emphasis: "low", type: "button" }, props, { lss: __assign({ display: 'flex', px: 'sm' }, props.lss) }),
        icon && (React.createElement(Icon, { as: icon, lss: {
                mr: !!label ? 'sm' : 0,
                color: iconPalette
            } })),
        label));
};
//# sourceMappingURL=CardHeaderAction.js.map